.ck{aspect-ratio:1/1;}